.calcpad {
  font-family: 'Sora', 'Manrope', 'Avenir Next', 'Segoe UI', sans-serif;
  color: #0f172a;
  background: radial-gradient(circle at 0% 0%, rgba(6, 182, 212, 0.13), transparent 35%), radial-gradient(circle at 100% 0%, rgba(14, 165, 233, 0.12), transparent 40%), linear-gradient(180deg, #f2f7fa 0%, #ebf2f6 100%);
}

.calcpad__header {
  border-bottom: 1px solid rgba(15, 23, 42, 0.12);
  background: rgba(255, 255, 255, 0.66);
  backdrop-filter: blur(8px);
}

.calcpad__eyebrow {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0e7490;
}

.calcpad__title {
  margin: 0.12rem 0 0;
  font-size: clamp(1.35rem, 2vw, 1.8rem);
  line-height: 1.1;
  letter-spacing: -0.02em;
  font-weight: 800;
}

.calcpad__subtitle {
  margin: 0.3rem 0 0;
  font-size: 0.92rem;
  color: #475569;
}

.calcpad__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.calcpad__stat {
  border: 1px solid rgba(14, 116, 144, 0.2);
  border-radius: 999px;
  background: rgba(236, 254, 255, 0.9);
  padding: 0.28rem 0.72rem;
  font-size: 0.73rem;
  font-weight: 700;
  color: #155e75;
}

.calcpad__stat--warning {
  border-color: rgba(185, 28, 28, 0.28);
  background: #fee2e2;
  color: #991b1b;
}

.calcpad__status {
  font-size: 0.76rem;
  font-weight: 600;
}

.calcpad__status--ok {
  color: #0f766e;
}

.calcpad__status--error {
  color: #b91c1c;
}

.calcpad__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  align-items: center;
}

.calcpad__action-btn {
  border: 1px solid rgba(15, 23, 42, 0.14);
  border-radius: 0.7rem;
  background: #ffffff;
  padding: 0.5rem 0.8rem;
  font-size: 0.8rem;
  font-weight: 700;
  transition:
    transform 120ms ease,
    box-shadow 120ms ease;
}

.calcpad__action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 7px 14px rgba(15, 23, 42, 0.12);
}

.calcpad__action-btn--primary {
  border-color: rgba(3, 105, 161, 0.4);
  background: linear-gradient(135deg, #0284c7, #0369a1);
  color: #ffffff;
}

.calcpad__filters {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 0.6rem;
}

.calcpad__field {
  grid-column: span 3;
}

.calcpad__field--search {
  grid-column: span 5;
}

.calcpad__label {
  display: block;
  margin-bottom: 0.18rem;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #334155;
}

.calcpad__control {
  width: 100%;
  border: 1px solid rgba(15, 23, 42, 0.15);
  border-radius: 0.65rem;
  background: #ffffff;
  padding: 0.52rem 0.7rem;
  font-size: 0.86rem;
}

.calcpad__control:focus {
  outline: none;
  border-color: #0369a1;
  box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.18);
}

.calcpad__clear-btn {
  align-self: end;
  border: 1px dashed rgba(14, 116, 144, 0.45);
  border-radius: 0.65rem;
  background: rgba(224, 242, 254, 0.9);
  color: #075985;
  padding: 0.5rem 0.7rem;
  font-size: 0.8rem;
  font-weight: 700;
}

.calcpad__workspace {
  display: grid;
  grid-template-columns: minmax(280px, 34%) minmax(0, 1fr);
  gap: 0.9rem;
}

.calcpad__list-pane,
.calcpad__detail-pane {
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(15, 23, 42, 0.11);
  border-radius: 1rem;
  backdrop-filter: blur(8px);
}

.calcpad__list-pane {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.calcpad__pane-header {
  padding: 0.95rem 0.95rem 0.72rem;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.calcpad__pane-title {
  margin: 0;
  font-size: 0.98rem;
  font-weight: 800;
}

.calcpad__pane-subtitle {
  margin: 0.25rem 0 0;
  font-size: 0.78rem;
  color: #64748b;
}

.calcpad__selection-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.6rem;
  margin-top: 0.75rem;
}

.calcpad__select-all {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.78rem;
  font-weight: 700;
}

.calcpad__checkbox {
  flex: 0 0 auto;
  width: 1.1rem;
  height: 1.1rem;
  margin-top: 0.15rem;
  accent-color: #0369a1;
  cursor: pointer;
}

.calcpad__selection-count {
  font-size: 0.76rem;
  color: #475569;
}

.calcpad button:disabled,
.calcpad input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.calcpad__checkbox:focus-visible {
  outline: 2px solid #0369a1;
  outline-offset: 3px;
}

.calcpad__list {
  padding: 0.85rem;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.calcpad__item {
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 0.8rem;
  background: rgba(255, 255, 255, 0.92);
  padding: 0.72rem;
  cursor: pointer;
  transition:
    transform 120ms ease,
    box-shadow 120ms ease;
  display: flex;
  gap: 0.6rem;
  justify-content: space-between;
}

.calcpad__item:hover {
  transform: translateY(-1px);
  box-shadow: 0 9px 16px rgba(15, 23, 42, 0.1);
}

.calcpad__item--active {
  border-color: rgba(2, 132, 199, 0.55);
  background: linear-gradient(180deg, rgba(224, 242, 254, 0.9), rgba(255, 255, 255, 0.98));
}

.calcpad__item--stale {
  border-color: rgba(185, 28, 28, 0.35);
}

.calcpad__item--selected {
  box-shadow: inset 3px 0 #0369a1;
}

.calcpad__item-main {
  min-width: 0;
  flex: 1;
}

.calcpad__item-title-row {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  min-width: 0;
}

.calcpad__item-title {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calcpad__version-badge {
  flex: 0 0 auto;
  border-radius: 999px;
  padding: 0.13rem 0.38rem;
  font-size: 0.62rem;
  font-weight: 800;
  line-height: 1.2;
  white-space: nowrap;
}

.calcpad__version-badge--required {
  background: #fee2e2;
  color: #991b1b;
}

.calcpad__version-badge--recommended {
  background: #fef3c7;
  color: #92400e;
}

.calcpad__item-meta,
.calcpad__item-time {
  margin: 0.2rem 0 0;
  font-size: 0.73rem;
  color: #64748b;
}

.calcpad__item-actions {
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
}

.calcpad__mini-btn {
  border: 1px solid rgba(2, 132, 199, 0.3);
  background: #f0f9ff;
  border-radius: 0.5rem;
  color: #075985;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 0.2rem 0.5rem;
}

.calcpad__mini-btn--danger {
  border-color: rgba(220, 38, 38, 0.25);
  background: #fee2e2;
  color: #991b1b;
}

.calcpad__detail-pane {
  overflow: auto;
}

.calcpad__detail-inner {
  padding: 1rem;
}

.calcpad__detail-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 800;
}

.calcpad__detail-grid {
  margin-top: 0.75rem;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.5rem;
}

.calcpad__detail-grid > div {
  border: 1px solid rgba(15, 23, 42, 0.11);
  border-radius: 0.65rem;
  background: #ffffff;
  padding: 0.55rem;
}

.calcpad__detail-grid span {
  display: block;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.calcpad__detail-grid strong {
  display: block;
  margin-top: 0.12rem;
  font-size: 0.8rem;
  color: #0f172a;
}

.calcpad__notes {
  margin: 0.65rem 0 0;
  font-size: 0.82rem;
  color: #475569;
}

.calcpad__version-alert {
  margin-top: 0.75rem;
  border-radius: 0.75rem;
  padding: 0.7rem 0.8rem;
  font-size: 0.82rem;
}

.calcpad__version-alert strong,
.calcpad__version-alert span {
  display: block;
}

.calcpad__version-alert strong {
  margin-bottom: 0.2rem;
  font-size: 0.78rem;
  text-transform: uppercase;
}

.calcpad__version-alert--required {
  border: 1px solid rgba(185, 28, 28, 0.25);
  background: #fef2f2;
  color: #7f1d1d;
}

.calcpad__version-alert--recommended {
  border: 1px solid rgba(217, 119, 6, 0.26);
  background: #fffbeb;
  color: #78350f;
}

.calcpad__share {
  margin-top: 0.85rem;
  border: 1px solid rgba(15, 23, 42, 0.11);
  border-radius: 0.8rem;
  background: rgba(248, 250, 252, 0.95);
  padding: 0.75rem;
}

.calcpad__share-label {
  font-size: 0.74rem;
  font-weight: 700;
  color: #334155;
  margin-bottom: 0.4rem;
}

.calcpad__share-row {
  display: flex;
  gap: 0.45rem;
}

.calcpad__share-input {
  flex: 1;
  min-width: 0;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 0.6rem;
  background: #ffffff;
  padding: 0.45rem 0.55rem;
  font-size: 0.72rem;
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
}

.calcpad__tabs {
  margin-top: 0.8rem;
  display: flex;
  gap: 0.45rem;
  border-bottom: 1px solid rgba(15, 23, 42, 0.12);
}

.calcpad__tab {
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #64748b;
  padding: 0.45rem 0.7rem;
  font-size: 0.78rem;
  font-weight: 700;
}

.calcpad__tab--active {
  color: #0369a1;
  border-bottom-color: #0369a1;
}

.calcpad__json {
  margin-top: 0.8rem;
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 0.8rem;
  background: #f8fafc;
  max-height: min(58vh, 720px);
  overflow: auto;
}

.calcpad__json pre {
  margin: 0;
  padding: 0.85rem;
  font-size: 0.76rem;
  color: #0f172a;
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
  white-space: pre-wrap;
}

.calcpad__charts-grid {
  margin-top: 0.8rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1rem;
}

.calcpad__chart-item {
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 0.8rem;
  background: #f8fafc;
  overflow: hidden;
}

.calcpad__chart-label {
  margin: 0;
  padding: 0.45rem 0.8rem;
  font-size: 0.73rem;
  font-weight: 600;
  color: #475569;
  text-transform: capitalize;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.calcpad__chart-img {
  display: block;
  width: 100%;
  height: auto;
}

.calcpad__empty,
.calcpad__empty-detail {
  margin: 0.95rem;
  border: 1px dashed rgba(15, 23, 42, 0.22);
  border-radius: 0.9rem;
  background: rgba(255, 255, 255, 0.78);
  text-align: center;
  color: #64748b;
  padding: 1.2rem;
}

.calcpad__empty-detail {
  margin: 1rem;
}

.calcpad__empty-detail p {
  margin: 0.25rem 0;
}

@media (max-width: 1180px) {
  .calcpad__field {
    grid-column: span 4;
  }

  .calcpad__field--search {
    grid-column: span 8;
  }

  .calcpad__workspace {
    grid-template-columns: 1fr;
  }

  .calcpad__list-pane {
    max-height: 42vh;
  }

  .calcpad__detail-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .calcpad__filters {
    grid-template-columns: 1fr;
  }

  .calcpad__field,
  .calcpad__field--search {
    grid-column: span 1;
  }

  .calcpad__actions {
    width: 100%;
  }

  .calcpad__action-btn {
    flex: 1;
  }

  .calcpad__detail-grid {
    grid-template-columns: 1fr;
  }

  .calcpad__share-row {
    flex-direction: column;
  }
}
